module.exports = __webpack_public_path__ + "static/media/arrow-left.9f71fb98.svg";